<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <svg
    :width="width"
    :height="width"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="group"
  >
    <path
      :class="styles"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.34058 2.07621C4.34058 3.20809 3.47875 4.12409 2.131 4.12409C0.835758 4.12409 -0.0260696 3.20809 0.000602035 2.07621C-0.0260696 0.889328 0.835737 0 2.15682 0C3.47873 0 4.31474 0.889328 4.34058 2.07621ZM0.10896 18.926V5.74188H4.20638V18.9251H0.10896V18.926Z"
    />
    <path
      :class="styles"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.49117 9.94954C7.49117 8.30507 7.43699 6.90314 7.38281 5.74376H10.9418L11.131 7.54993H11.2119C11.7511 6.71394 13.0989 5.44788 15.2826 5.44788C17.9781 5.44788 20.0002 7.22737 20.0002 11.1081V18.9279H15.9027V11.6215C15.9027 9.92203 15.3101 8.76348 13.8273 8.76348C12.6946 8.76348 12.0212 9.54529 11.752 10.2996C11.6436 10.5696 11.5903 10.9464 11.5903 11.3248V18.9279H7.49282V9.94954H7.49117Z"
    />
  </svg>
</template>

<script lang="ts" setup>
import { defineProps, computed, toRefs } from "vue";
export interface IconLinkProps {
  color?: string;
  width?: string;
  height?: string;
  classes?: string;
}

const props = withDefaults(defineProps<IconLinkProps>(), {
  color: "white",
  width: "100%",
  height: "100%",
});

const { color, width, height, classes } = toRefs(props);
const styles = computed(() => {
  return `${color.value} group-hover:fill-orange transition-colors ${classes?.value}`;
});
</script>
